"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameVars_1 = require("../GameVars");
var AudioManager_1 = require("../AudioManager");
var GameConstants_1 = require("../GameConstants");
var BoardState_1 = require("./BoardState");
var ConnectionManager_1 = require("../ConnectionManager");
var LocalServer_1 = require("../LocalServer");
var FinishLayer = /** @class */ (function (_super) {
    __extends(FinishLayer, _super);
    function FinishLayer(game, win) {
        var _this = _super.call(this, game, null, "finish-layer") || this;
        _this.clicked = false;
        var bck = new Phaser.Sprite(_this.game, 0, 0, _this.game.cache.getBitmapData(GameConstants_1.GameConstants.BLACK_SQUARE));
        bck.scale.set(GameConstants_1.GameConstants.GAME_WIDTH / GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.GAME_HEIGHT / GameConstants_1.GameConstants.BITMAP_SIZE);
        bck.alpha = .75;
        bck.inputEnabled = true;
        bck.events.onInputDown.add(_this.bckDown, _this);
        _this.add(bck);
        var midContainer = new Phaser.Group(_this.game);
        midContainer.position.set(GameConstants_1.GameConstants.GAME_WIDTH / 2, GameConstants_1.GameConstants.GAME_HEIGHT / 2);
        midContainer.scale.y = GameVars_1.GameVars.scaleY;
        _this.add(midContainer);
        _this.alpha = .001;
        _this.visible = true;
        _this.game.add.tween(_this)
            .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, 500);
        var title = new Phaser.Text(_this.game, 0, -320, "", { font: "70px Eczar", fill: "#fff17f ", align: "center" });
        title.anchor.set(.5);
        title.strokeThickness = 8;
        title.addStrokeColor("#FFFFFF", 0);
        midContainer.add(title);
        var grd = title.context.createLinearGradient(0, 0, 0, title.height);
        //  Add in 2 color stops
        grd.addColorStop(0, "#00BDFF");
        grd.addColorStop(1, "#1262B5");
        //  And apply to the Text
        title.fill = grd;
        var gzpScore = 0;
        if (win === GameConstants_1.GameConstants.FINAL_OUT_OF_MOVES) {
            title.text = "Out of Moves";
        }
        else if (win === GameConstants_1.GameConstants.FINAL_TIME) {
            title.text = "Out of Time";
        }
        else {
            title.text = "Game Completed";
            gzpScore = 1;
        }
        var tmpScore = GameVars_1.GameVars.points;
        ConnectionManager_1.ConnectionManager.isGameEnd = true;
        if (GameVars_1.GameVars.gzpGameMode != "tournament") {
            window.setTimeout(function () {
                gamezop.setState({
                    state: "over",
                    score: tmpScore,
                    metadata: oMetaManager.meta
                });
            }, 2500);
        }
        var image = new Phaser.Image(_this.game, 0, -120, "texture_atlas_1", "box_score");
        image.anchor.set(.5);
        midContainer.add(image);
        image = new Phaser.Image(_this.game, 0, 120, "texture_atlas_1", "box_best_score");
        image.anchor.set(.5);
        midContainer.add(image);
        var points = new Phaser.Text(_this.game, 0, -92, " " + GameVars_1.GameVars.points + " pts ", { font: "40px Futura", fill: "#fff17f ", align: "center" });
        points.anchor.set(.5);
        points.setShadow(3, 3, "rgba(0,0,0,0.5)", 3);
        midContainer.add(points);
        var gzpHighScore = GameVars_1.GameVars.maxPoints;
        if (GameVars_1.GameVars.gzpGameMode === "battle") {
            gzpHighScore = GameVars_1.GameVars.points;
        }
        var maxPoints = new Phaser.Text(_this.game, 0, 150, " " + gzpHighScore + " pts ", { font: "40px Futura", fill: "#fff17f ", align: "center" });
        maxPoints.anchor.set(.5);
        maxPoints.setShadow(3, 3, "rgba(0,0,0,0.5)", 3);
        midContainer.add(maxPoints);
        grd = points.context.createLinearGradient(0, 0, 0, points.height);
        //  Add in 2 color stops
        grd.addColorStop(0, "#ffff00");
        grd.addColorStop(1, "#ffc509");
        //  And apply to the Text
        points.fill = grd;
        maxPoints.fill = grd;
        var playButton = new Phaser.Button(_this.game, 0, 350, "texture_atlas_1", _this.onClickRematch, _this);
        playButton.setFrames("btn_replay", "btn_replay", "btn_replay");
        playButton.anchor.set(.5);
        playButton.input.pixelPerfectOver = true;
        playButton.forceOut = true;
        if (ConnectionManager_1.ConnectionManager.isBattle) {
            playButton.visible = false;
        }
        midContainer.add(playButton);
        return _this;
    }
    FinishLayer.prototype.onClickRematch = function () {
        if (this.clicked) {
            return;
        }
        this.clicked = true;
        BoardState_1.BoardState.currentInstance.game.state.start("BoardState", true, false);
        AudioManager_1.AudioManager.getInstance().playSound("btn_press");
        LocalServer_1.LocalServer.ResetTimer();
    };
    FinishLayer.prototype.bckDown = function () {
        // 
    };
    return FinishLayer;
}(Phaser.Group));
exports.FinishLayer = FinishLayer;
